export default __webpack_public_path__ + "static/media/tick.9beba42c.svg";